(function ($) {
  gnavCartV1 = {
    formatter: $('.gnav-cart-v1')
  };

  Drupal.behaviors.gnavCartV1 = {
    get: function (key) {
      return gnavCartV1[key];
    },

    set: function (key, val) {
      gnavCartV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        // setup for cart-specific styles
        thisFormatter.parents('.block-nodeblock').addClass('gnav-cart');

        // use cart_path field to create header cart icon link
        var cartPath = thisFormatter.attr('cart-path');

        if (typeof cartPath !== 'undefined' && cartPath !== false) {
          var icon = thisFormatter.parents('.gnav-drop-down-v1').find('.link');

          icon.once('template-icon').on('click', function() {
            window.location.assign(cartPath);
          });
        }
      });
    }
  };
})(jQuery);
